"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/wrapNativeSuper"));
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _triggerProxy = _interopRequireDefault(require("../common/events/trigger-proxy"));
var _constants = require("../constants");
var _constants2 = _interopRequireDefault(require("../metrics/constants"));
var _reconnection = _interopRequireDefault(require("../common/errors/reconnection"));
var _reconnectionNotStarted = _interopRequireDefault(require("../common/errors/reconnection-not-started"));
var _metrics = _interopRequireDefault(require("../metrics"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } /*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */ /* eslint-disable no-warning-comments */
/**
 * Used to indicate that the reconnect logic needs to be retried.
 *
 * @class NeedsRetryError
 * @extends {Error}
 */
var NeedsRetryError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(NeedsRetryError, _Error);
  var _super = _createSuper(NeedsRetryError);
  function NeedsRetryError() {
    (0, _classCallCheck2.default)(this, NeedsRetryError);
    return _super.apply(this, arguments);
  }
  return (0, _createClass2.default)(NeedsRetryError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
/**
 * Used to indicate that the meeting needs to be rejoined, not just media reconnected
 *
 * @class NeedsRejoinError
 * @extends {Error}
 */
var NeedsRejoinError = /*#__PURE__*/function (_Error2) {
  (0, _inherits2.default)(NeedsRejoinError, _Error2);
  var _super2 = _createSuper(NeedsRejoinError);
  /**
   * Creates an instance of NeedsRejoinError.
   * @param {Object} params
   * @param {boolean} params.wasSharing
   * @param {Error} params.error
   * @memberof NeedsRejoinError
   */
  function NeedsRejoinError(_ref) {
    var _this;
    var wasSharing = _ref.wasSharing,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? new Error('Meeting needs to be rejoined') : _ref$error;
    (0, _classCallCheck2.default)(this, NeedsRejoinError);
    // @ts-ignore
    _this = _super2.call(this, error);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "wasSharing", void 0);
    _this.wasSharing = wasSharing;
    return _this;
  }
  return (0, _createClass2.default)(NeedsRejoinError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
/**
 * @export
 * @class ReconnectionManager
 */
var ReconnectionManager = exports.default = /*#__PURE__*/function () {
  /**
   * @param {Meeting} meeting
   */
  function ReconnectionManager(meeting) {
    (0, _classCallCheck2.default)(this, ReconnectionManager);
    (0, _defineProperty2.default)(this, "autoRejoinEnabled", void 0);
    (0, _defineProperty2.default)(this, "iceState", void 0);
    (0, _defineProperty2.default)(this, "maxRejoinAttempts", void 0);
    (0, _defineProperty2.default)(this, "meeting", void 0);
    (0, _defineProperty2.default)(this, "rejoinAttempts", void 0);
    (0, _defineProperty2.default)(this, "shareStatus", void 0);
    (0, _defineProperty2.default)(this, "status", void 0);
    (0, _defineProperty2.default)(this, "webex", void 0);
    /**
     * Stores ICE reconnection state data.
     *
     * @instance
     * @type {Object}
     * @private
     * @memberof ReconnectionManager
     */
    this.iceState = {
      disconnected: false,
      resolve: function resolve() {},
      timer: undefined,
      // @ts-ignore
      timeoutDuration: meeting.config.reconnection.iceReconnectionTimeout
    };

    /**
     * @instance
     * @type {RECONNECTION_STATE}
     * @private
     * @memberof ReconnectionManager
     */
    this.status = _constants.RECONNECTION.STATE.DEFAULT_STATUS;
    /**
     * @instance
     * @type {Object}
     * @private
     * @memberof ReconnectionManager
     */
    // TODO : change this logic to not save the meeting instance
    // It gets complicated when meeting ends on remote side , We have a old meeting instance which is not up to date
    // @ts-ignore
    this.webex = meeting.webex;
    /**
     * @instance
     * @type {Meeting}
     * @private
     * @memberof ReconnectionManager
     */
    // TODO: try removing the circular dependency for meeting and reconnection manager
    // try moving this to meetings collection
    this.meeting = meeting;

    // @ts-ignore
    this.maxRejoinAttempts = meeting.config.reconnection.maxRejoinAttempts;
    this.rejoinAttempts = 0;
    // @ts-ignore
    this.autoRejoinEnabled = meeting.config.reconnection.autoRejoin;

    // Make sure reconnection state is in default
    this.reset();
  }

  /**
   * @public
   * @memberof ReconnectionManager
   * @returns {void}
   */
  (0, _createClass2.default)(ReconnectionManager, [{
    key: "resetReconnectionTimer",
    value: function resetReconnectionTimer() {
      this.iceState.resolve();
      this.iceState.resolve = function () {};
      if (this.iceState.timer) {
        clearTimeout(this.iceState.timer);
        delete this.iceState.timer;
      }
    }

    /**
     * Sets the iceState to connected and clears any disconnect timeouts and
     * related timeout data within the iceState.
     *
     * @returns {undefined}
     * @public
     * @memberof ReconnectionManager
     */
  }, {
    key: "iceReconnected",
    value: function iceReconnected() {
      if (this.iceState.disconnected) {
        _loggerProxy.default.logger.log('ReconnectionManager:index#iceReconnected --> ice has reconnected');
        this.resetReconnectionTimer();
        this.iceState.disconnected = false;
      }
    }

    /**
     * Set the iceState to disconnected and generates a timeout that waits for the
     * iceState to reconnect and then resolves. If the ice state is already
     * processing a reconnect, it immediately resolves. Rejects if the timeout
     * duration is reached.
     *
     * @returns {Promise<undefined>}
     * @public
     * @memberof ReconnectionManager
     */
  }, {
    key: "waitForIceReconnect",
    value: function waitForIceReconnect() {
      var _this2 = this;
      if (!this.iceState.disconnected) {
        _loggerProxy.default.logger.log('ReconnectionManager:index#waitForIceReconnect --> waiting for ice reconnect');
        this.iceState.disconnected = true;
        return new _promise.default(function (resolve, reject) {
          _this2.iceState.timer = setTimeout(function () {
            if (_this2.iceState.disconnected === false) {
              resolve();
            } else {
              _this2.iceState.disconnected = false;
              reject(new Error("ice reconnection did not occur in ".concat(_this2.iceState.timeoutDuration, "ms")));
            }
          }, _this2.iceState.timeoutDuration);
          _this2.iceState.resolve = resolve;
        });
      }

      // return a resolved promise to prevent multiple catch executions of reconnect
      return _promise.default.resolve();
    }

    /**
     * @returns {undefined}
     * @public
     * @memberof ReconnectionManager
     */
  }, {
    key: "reset",
    value: function reset() {
      this.status = _constants.RECONNECTION.STATE.DEFAULT_STATUS;
      this.rejoinAttempts = 0;
    }

    /**
     * @returns {undefined}
     * @public
     * @memberof ReconnectionManager
     */
  }, {
    key: "cleanUp",
    value: function cleanUp() {
      this.reset();
    }

    /**
     * Stop the local share stream.
     *
     * @param {string} reason a {@link SHARE_STOPPED_REASON}
     * @returns {undefined}
     * @private
     * @memberof ReconnectionManager
     */
  }, {
    key: "stopLocalShareStream",
    value: (function () {
      var _stopLocalShareStream = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(reason) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.meeting.unpublishStreams([this.meeting.mediaProperties.shareVideoStream, this.meeting.mediaProperties.shareAudioStream]);
            case 2:
              _triggerProxy.default.trigger(this.meeting, {
                file: 'reconnection-manager/index',
                function: 'stopLocalShareStream'
              }, _constants.EVENT_TRIGGERS.MEETING_STOPPED_SHARING_LOCAL, {
                reason: reason
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function stopLocalShareStream(_x) {
        return _stopLocalShareStream.apply(this, arguments);
      }
      return stopLocalShareStream;
    }()
    /**
     * @public
     * @memberof ReconnectionManager
     * @returns {Boolean} true if reconnection operation is in progress
     */
    )
  }, {
    key: "isReconnectInProgress",
    value: function isReconnectInProgress() {
      return this.status === _constants.RECONNECTION.STATE.IN_PROGRESS;
    }

    /**
     * @returns {Boolean}
     * @throws {ReconnectInProgress, ReconnectionDisabled}
     * @private
     * @memberof ReconnectionManager
     */
  }, {
    key: "canStartReconnection",
    value: function canStartReconnection() {
      if (this.meeting.config.reconnection.enabled) {
        if (this.status === _constants.RECONNECTION.STATE.DEFAULT_STATUS) {
          return true;
        }
        _loggerProxy.default.logger.info('ReconnectionManager:index#canStartReconnection --> Reconnection already in progress.');
        return false;
      }
      _loggerProxy.default.logger.info('ReconnectionManager:index#canStartReconnection --> Reconnection is not enabled.');
      return false;
    }

    /**
     * Initiates a media reconnect for the active meeting
     * @param {Object} reconnectOptions
     * @param {boolean} [reconnectOptions.networkDisconnect=false] indicates if a network disconnect event happened
     * @param {boolean} [reconnectOptions.networkRetry=false] indicates if we are retrying the reconnect
     * @param {Function} [completionCallback] callback that gets called when reconnection is started successfully
     * @returns {Promise}
     * @public
     * @memberof ReconnectionManager
     */
  }, {
    key: "reconnect",
    value: (function () {
      var _reconnect = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this3 = this;
        var _ref2,
          _ref2$networkDisconne,
          networkDisconnect,
          _ref2$networkRetry,
          networkRetry,
          completionCallback,
          triggerEvent,
          _args2 = arguments;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref2 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref2$networkDisconne = _ref2.networkDisconnect, networkDisconnect = _ref2$networkDisconne === void 0 ? false : _ref2$networkDisconne, _ref2$networkRetry = _ref2.networkRetry, networkRetry = _ref2$networkRetry === void 0 ? false : _ref2$networkRetry;
              completionCallback = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : undefined;
              _loggerProxy.default.logger.info("ReconnectionManager:index#reconnect --> Reconnection start for meeting ".concat(this.meeting.id, "."));
              triggerEvent = function triggerEvent(event) {
                var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                return _triggerProxy.default.trigger(_this3.meeting, {
                  file: 'reconnection-manager/index',
                  function: 'reconnect'
                }, event, payload);
              };
              if (this.canStartReconnection()) {
                _context2.next = 6;
                break;
              }
              throw new _reconnectionNotStarted.default();
            case 6:
              _context2.prev = 6;
              this.status = _constants.RECONNECTION.STATE.IN_PROGRESS;
              triggerEvent(_constants.EVENT_TRIGGERS.MEETING_RECONNECTION_STARTING);
              if (!networkRetry) {
                // Only log START metrics on the initial reconnect
                _loggerProxy.default.logger.info('ReconnectionManager:index#reconnect --> Sending reconnect start metric.');

                // @ts-ignore
                this.webex.internal.newMetrics.submitClientEvent({
                  name: 'client.media.reconnecting',
                  options: {
                    meetingId: this.meeting.id
                  }
                });
              }
              _context2.prev = 10;
              _context2.next = 13;
              return this.webex.meetings.startReachability('reconnection');
            case 13:
              _context2.next = 18;
              break;
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](10);
              _loggerProxy.default.logger.info('ReconnectionManager:index#reconnect --> Reachability failed, continuing with reconnection attempt, err: ', _context2.t0);
            case 18:
              _context2.prev = 18;
              _context2.next = 21;
              return this.executeReconnection({
                networkDisconnect: networkDisconnect
              });
            case 21:
              _context2.next = 38;
              break;
            case 23:
              _context2.prev = 23;
              _context2.t1 = _context2["catch"](18);
              if (!(_context2.t1 instanceof NeedsRetryError)) {
                _context2.next = 31;
                break;
              }
              _loggerProxy.default.logger.info('ReconnectionManager:index#reconnect --> Reconnection not successful, retrying.');
              // Reset our reconnect status since we are looping back to the beginning
              this.status = _constants.RECONNECTION.STATE.DEFAULT_STATUS;

              // This is a network retry, so we should not log START metrics again
              _context2.next = 30;
              return this.reconnect({
                networkDisconnect: true,
                networkRetry: true
              }, completionCallback);
            case 30:
              return _context2.abrupt("return");
            case 31:
              // Reconnect has failed
              _loggerProxy.default.logger.error('ReconnectionManager:index#reconnect --> Reconnection failed.', _context2.t1.message);

              // send call aborted event with category as expected as we are trying to rejoin
              // @ts-ignore
              this.webex.internal.newMetrics.submitClientEvent({
                name: 'client.call.aborted',
                payload: {
                  errors: [{
                    category: 'expected',
                    errorCode: 2008,
                    fatal: true,
                    name: 'media-engine',
                    shownToUser: false
                  }]
                },
                options: {
                  meetingId: this.meeting.id
                }
              });
              if (!(_context2.t1 instanceof NeedsRejoinError && this.autoRejoinEnabled)) {
                _context2.next = 37;
                break;
              }
              _context2.next = 36;
              return this.rejoinMeeting(_context2.t1.wasSharing);
            case 36:
              return _context2.abrupt("return");
            case 37:
              throw _context2.t1;
            case 38:
              if (!completionCallback) {
                _context2.next = 41;
                break;
              }
              _context2.next = 41;
              return completionCallback();
            case 41:
              triggerEvent(_constants.EVENT_TRIGGERS.MEETING_RECONNECTION_SUCCESS);

              // @ts-ignore
              this.webex.internal.newMetrics.submitClientEvent({
                name: 'client.media.recovered',
                payload: {
                  recoveredBy: 'new'
                },
                options: {
                  meetingId: this.meeting.id
                }
              });
              _context2.next = 50;
              break;
            case 45:
              _context2.prev = 45;
              _context2.t2 = _context2["catch"](6);
              triggerEvent(_constants.EVENT_TRIGGERS.MEETING_RECONNECTION_FAILURE, {
                error: new _reconnection.default('Reconnection failure event', _context2.t2)
              });
              _metrics.default.sendBehavioralMetric(_constants2.default.MEETING_RECONNECT_FAILURE, {
                correlation_id: this.meeting.correlationId,
                locus_id: this.meeting.locusUrl.split('/').pop(),
                reason: _context2.t2.message,
                stack: _context2.t2.stack
              });
              throw new _reconnection.default('Reconnection failure event', _context2.t2);
            case 50:
              _context2.prev = 50;
              this.reset();
              return _context2.finish(50);
            case 53:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[6, 45, 50, 53], [10, 15], [18, 23]]);
      }));
      function reconnect() {
        return _reconnect.apply(this, arguments);
      }
      return reconnect;
    }()
    /**
     * @param {Object} reconnectOptions
     * @param {boolean} [reconnectOptions.networkDisconnect=false] indicates if a network disconnect event happened
     * @returns {Promise}
     * @throws {NeedsRetryError}
     * @private
     * @memberof ReconnectionManager
     */
    )
  }, {
    key: "executeReconnection",
    value: (function () {
      var _executeReconnection = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(_ref3) {
        var _ref3$networkDisconne, networkDisconnect, wasSharing, media;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _ref3$networkDisconne = _ref3.networkDisconnect, networkDisconnect = _ref3$networkDisconne === void 0 ? false : _ref3$networkDisconne;
              _loggerProxy.default.logger.info('ReconnectionManager:index#executeReconnection --> Attempting to reconnect to meeting.');
              wasSharing = this.meeting.shareStatus === _constants.SHARE_STATUS.LOCAL_SHARE_ACTIVE;
              if (!wasSharing) {
                _context3.next = 6;
                break;
              }
              _context3.next = 6;
              return this.stopLocalShareStream(_constants.SHARE_STOPPED_REASON.MEDIA_RECONNECTION);
            case 6:
              if (!networkDisconnect) {
                _context3.next = 18;
                break;
              }
              _context3.prev = 7;
              _context3.next = 10;
              return this.reconnectMercuryWebSocket();
            case 10:
              _loggerProxy.default.logger.error('ReconnectionManager:index#executeReconnection --> Websocket reconnected.', this.webex.internal.device.url);
              _context3.next = 18;
              break;
            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](7);
              _loggerProxy.default.logger.error('ReconnectionManager:index#executeReconnection --> Unable to reconnect to websocket, giving up.');
              this.status = _constants.RECONNECTION.STATE.FAILURE;
              throw _context3.t0;
            case 18:
              _context3.prev = 18;
              _loggerProxy.default.logger.info('ReconnectionManager:index#executeReconnection --> Updating meeting data from server.');
              _context3.next = 22;
              return this.webex.meetings.syncMeetings({
                keepOnlyLocusMeetings: false
              });
            case 22:
              _context3.next = 28;
              break;
            case 24:
              _context3.prev = 24;
              _context3.t1 = _context3["catch"](18);
              _loggerProxy.default.logger.info('ReconnectionManager:index#executeReconnection --> Unable to sync meetings, reconnecting.', _context3.t1);
              throw new NeedsRetryError(_context3.t1);
            case 28:
              if (!(!this.meeting || !this.webex.meetings.getMeetingByType(_constants._ID_, this.meeting.id))) {
                _context3.next = 31;
                break;
              }
              _loggerProxy.default.logger.info('ReconnectionManager:index#executeReconnection --> Meeting got deleted due to inactivity or ended remotely.');
              throw new Error('Unable to rejoin a meeting already ended or inactive.');
            case 31:
              _loggerProxy.default.logger.info("ReconnectionManager:index#executeReconnection --> Current state of meeting is ".concat(this.meeting.state));

              // If the meeting state was left, no longer reconnect media
              if (!(this.meeting.state === _constants._LEFT_)) {
                _context3.next = 36;
                break;
              }
              if (!(this.meeting.type === _constants._CALL_)) {
                _context3.next = 35;
                break;
              }
              throw new Error('Unable to rejoin a call in LEFT state.');
            case 35:
              throw new NeedsRejoinError({
                wasSharing: wasSharing
              });
            case 36:
              _context3.prev = 36;
              _context3.next = 39;
              return this.reconnectMedia();
            case 39:
              media = _context3.sent;
              _loggerProxy.default.logger.log('ReconnectionManager:index#executeReconnection --> webRTC media connection renewed and local sdp offer sent');
              return _context3.abrupt("return", media);
            case 44:
              _context3.prev = 44;
              _context3.t2 = _context3["catch"](36);
              _loggerProxy.default.logger.error('ReconnectionManager:index#executeReconnection --> failed to renew webRTC media connection or initiate offer');
              this.status = _constants.RECONNECTION.STATE.FAILURE;
              throw _context3.t2;
            case 49:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[7, 13], [18, 24], [36, 44]]);
      }));
      function executeReconnection(_x2) {
        return _executeReconnection.apply(this, arguments);
      }
      return executeReconnection;
    }()
    /**
     * Rejoins a meeting after detecting the member was in a LEFT state
     *
     * @async
     * @param {boolean} wasSharing
     * @returns {Promise}
     */
    )
  }, {
    key: "rejoinMeeting",
    value: (function () {
      var _rejoinMeeting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var wasSharing,
          _args4 = arguments;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              wasSharing = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : false;
              _context4.prev = 1;
              _loggerProxy.default.logger.info('ReconnectionManager:index#rejoinMeeting --> attemping meeting rejoin');
              _context4.next = 5;
              return this.meeting.join({
                rejoin: true
              });
            case 5:
              _loggerProxy.default.logger.info('ReconnectionManager:index#rejoinMeeting --> meeting rejoined');
              if (!wasSharing) {
                _context4.next = 9;
                break;
              }
              _context4.next = 9;
              return this.stopLocalShareStream(_constants.SHARE_STOPPED_REASON.MEETING_REJOIN);
            case 9:
              _context4.next = 23;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](1);
              this.rejoinAttempts += 1;
              if (!(this.rejoinAttempts <= this.maxRejoinAttempts)) {
                _context4.next = 19;
                break;
              }
              _loggerProxy.default.logger.info("ReconnectionManager:index#rejoinMeeting --> Unable to rejoin meeting, attempt #".concat(this.rejoinAttempts, ", retrying."), _context4.t0);
              this.rejoinMeeting();
              _context4.next = 23;
              break;
            case 19:
              _loggerProxy.default.logger.error('ReconnectionManager:index#rejoinMeeting --> Unable to rejoin meeting after max attempts.', _context4.t0);
              _metrics.default.sendBehavioralMetric(_constants2.default.MEETING_MAX_REJOIN_FAILURE, {
                locus_id: this.meeting.locusUrl.split('/').pop(),
                reason: _context4.t0.message,
                stack: _context4.t0.stack
              });
              this.status = _constants.RECONNECTION.STATE.FAILURE;
              throw _context4.t0;
            case 23:
              _context4.prev = 23;
              _context4.next = 26;
              return this.reconnectMedia();
            case 26:
              _context4.next = 32;
              break;
            case 28:
              _context4.prev = 28;
              _context4.t1 = _context4["catch"](23);
              _loggerProxy.default.logger.error('ReconnectionManager:index#rejoinMeeting --> Unable to reestablish media after rejoining.', _context4.t1);
              throw _context4.t1;
            case 32:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 11], [23, 28]]);
      }));
      function rejoinMeeting() {
        return _rejoinMeeting.apply(this, arguments);
      }
      return rejoinMeeting;
    }()
    /**
     * @returns {Promise}
     * @private
     * @memberof ReconnectionManager
     */
    )
  }, {
    key: "reconnectMedia",
    value: (function () {
      var _reconnectMedia = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var _turnServerResult$tur;
        var turnServerResult, iceServers;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _loggerProxy.default.logger.log('ReconnectionManager:index#reconnectMedia --> do turn discovery');

              // do the TURN server discovery again and ignore reachability results since the TURN server might change
              _context5.next = 3;
              return this.meeting.roap.doTurnDiscovery(this.meeting, true, true);
            case 3:
              turnServerResult = _context5.sent;
              iceServers = [];
              if ((_turnServerResult$tur = turnServerResult.turnServerInfo) !== null && _turnServerResult$tur !== void 0 && _turnServerResult$tur.url) {
                iceServers.push({
                  urls: turnServerResult.turnServerInfo.url,
                  username: turnServerResult.turnServerInfo.username || '',
                  credential: turnServerResult.turnServerInfo.password || ''
                });
              }
              _loggerProxy.default.logger.log('ReconnectionManager:index#reconnectMedia --> renew webRTC media connection and send local sdp offer');
              _context5.next = 9;
              return this.meeting.mediaProperties.webrtcMediaConnection.reconnect(iceServers);
            case 9:
              // resend media requests
              if (this.meeting.isMultistream) {
                (0, _values.default)(this.meeting.mediaRequestManagers).forEach(function (mediaRequestManager) {
                  mediaRequestManager.clearPreviousRequests();
                  mediaRequestManager.commit();
                });
              }
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function reconnectMedia() {
        return _reconnectMedia.apply(this, arguments);
      }
      return reconnectMedia;
    }()
    /**
     * Attempt to Reconnect Mercury Websocket
     * @returns {Promise}
     * @private
     * @memberof ReconnectionManager
     */
    )
  }, {
    key: "reconnectMercuryWebSocket",
    value: (function () {
      var _reconnectMercuryWebSocket = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _loggerProxy.default.logger.info('ReconnectionManager:index#reconnectMercuryWebSocket --> Reconnecting websocket.');
              // First, attempt to disconnect if we think we are already connected.
              if (!this.webex.internal.mercury.connected) {
                _context6.next = 13;
                break;
              }
              _loggerProxy.default.logger.info('ReconnectionManager:index#reconnectMercuryWebSocket --> Disconnecting existing websocket.');
              _context6.prev = 3;
              _context6.next = 6;
              return this.webex.internal.mercury.disconnect();
            case 6:
              _loggerProxy.default.logger.info('ReconnectionManager:index#reconnectMercuryWebSocket --> Websocket disconnected successfully.');
              _context6.next = 13;
              break;
            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6["catch"](3);
              // If we can't disconnect, the sdk is in such a bad state that reconnecting is not going to happen.
              _loggerProxy.default.logger.error('ReconnectionManager:index#reconnectMercuryWebSocket --> Unable to disconnect from websocket, giving up.', _context6.t0);
              throw _context6.t0;
            case 13:
              _context6.prev = 13;
              _loggerProxy.default.logger.info('ReconnectionManager:index#reconnectMercuryWebSocket --> Connecting websocket.');
              _context6.next = 17;
              return this.webex.internal.mercury.connect();
            case 17:
              _loggerProxy.default.logger.info('ReconnectionManager:index#reconnectMercuryWebSocket --> Websocket connected successfully.');
              _context6.next = 24;
              break;
            case 20:
              _context6.prev = 20;
              _context6.t1 = _context6["catch"](13);
              _loggerProxy.default.logger.error('ReconnectionManager:index#reconnectMercuryWebSocket --> Unable to connect to websocket, giving up.', _context6.t1);
              throw _context6.t1;
            case 24:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[3, 9], [13, 20]]);
      }));
      function reconnectMercuryWebSocket() {
        return _reconnectMercuryWebSocket.apply(this, arguments);
      }
      return reconnectMercuryWebSocket;
    }())
  }]);
  return ReconnectionManager;
}();
//# sourceMappingURL=index.js.map
